import type { FaireProductEntity } from "../../entity_types/product";

export const p_y47sx37yfw: FaireProductEntity = {
  token: "p_y47sx37yfw",
  type: "product",
  name: "Organic Everyday Extra Virgin Olive Oil (500ml)",
  brandToken: "b_8v4yrvb98p",
  brandName: "Kosterina",
  imageUrl: "https://cdn.faire.com/fastly/8fc4dd5f49b78bfa36c3b201b89e04bb7f9988d4ac29bae8b0a5c35c2a40d409.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd959db20819612c903e4efb3d0184363b178e48aff75a0f3d46b8f1e3b1a393.png",
    "https://cdn.faire.com/fastly/47e6c72ffe7b75f8a3b0e73811685f8376aea1a844c35086c9dd173ea7a2f432.jpeg",
    "https://cdn.faire.com/fastly/1ec698e6c31b92a35709f0826a72bb4770f0c4f5e263396b65bb2530b2f7b2e8.png"
  ],
  priceDollars: 23.56,
  description: "While our Original Extra Virgin Olive Oil is absolutely your best choice for dipping and finishing, Kosterina Organic EVERYDAY EVOO is your new go-to for cooking, baking, roasting and grilling – anytime heat is applied! \n\nCrafted with cooks in mind, the Everyday has a mild, fruity flavor with a smooth finish that will not overpower your food. This oil stands up to heat beautifully and is able to maintain its flavor with a smoke point of over 400° F. \n\nLike our ultra-premium Original EVOO, the Everyday is made from 100% Koroneiki early harvest olives. The Everyday has a polyphenol content of over 300 mg/kg as measured at the time of harvest – that’s slightly less than the 470 mg/kg found in our Original EVOO but still over 6x what you can find in an average bottle at your local supermarket.",
  tags: [],
  msrpDollars: 34.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:57.419Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
